// Central react-query hooks — dedupes API calls across the app.
// Multiple components asking for the same resource share a single request + cache.
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

const fetcher = (path) => api.get(path).then((r) => r.data);

// staleTime long enough to avoid refetch during a session; QueryClient already has 30s default.
export const useSettings = () =>
  useQuery({ queryKey: ["settings"], queryFn: () => fetcher("/settings"), staleTime: 5 * 60_000 });

export const useServices = () =>
  useQuery({ queryKey: ["services"], queryFn: () => fetcher("/services"), staleTime: 5 * 60_000 });

export const useProjects = () =>
  useQuery({ queryKey: ["projects"], queryFn: () => fetcher("/projects"), staleTime: 5 * 60_000 });

export const useBrands = () =>
  useQuery({ queryKey: ["brands"], queryFn: () => fetcher("/brands"), staleTime: 5 * 60_000 });

export const useTestimonials = () =>
  useQuery({ queryKey: ["testimonials"], queryFn: () => fetcher("/testimonials"), staleTime: 5 * 60_000 });

export const useBts = () =>
  useQuery({ queryKey: ["bts"], queryFn: () => fetcher("/bts"), staleTime: 5 * 60_000 });

export const useShorts = () =>
  useQuery({ queryKey: ["shorts"], queryFn: () => fetcher("/shorts"), staleTime: 5 * 60_000 });
